export default __webpack_public_path__ + "static/layout-dont-dark-4954ff613aaa314a7c607a91ed0eff9e33a8579f118c4eec81a165910047ff67.png";